import Home from "./Home";
import Projects from "./Projects";
import Project from "./Project";
import ProjectDetails from "./ProjectDetails";
import Footer from "./Footer";
import About from "./About";
import Menu from "./Menu";
import Gallery from "./Gallery";
import Image from "./Image";
import Loading from "./Loading";
import NotFound from "./NotFound";

export {
  NotFound,
  Loading,
  Gallery,
  Image,
  ProjectDetails,
  Menu,
  Home,
  Projects,
  Project,
  Footer,
  About,
};



// WEBPACK FOOTER //
// ./src/components/index.js